const mediaItems = [
  {
    title: '顶流男星酒店密会全程监控',
    duration: '12:38',
    date: '2026.07.18',
    image: 'https://readdy.ai/api/search-image?query=Dark%20hotel%20corridor%20at%20night%20with%20dramatic%20security%20camera%20perspective%2C%20overhead%20fisheye%20view%2C%20dim%20lighting%2C%20cinematic%20surveillance%20aesthetic%2C%20warm%20tungsten%20glow%2C%20mysterious%20atmosphere%2C%20neo%20noir%20style%2C%20grainy%20texture&width=600&height=800&seq=media-video-01&orientation=portrait',
  },
  {
    title: '综艺节目录制现场冲突实录',
    duration: '08:15',
    date: '2026.07.17',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20control%20room%20with%20multiple%20monitors%20showing%20static%2C%20dramatic%20red%20recording%20light%2C%20dark%20atmosphere%2C%20broadcast%20equipment%2C%20tense%20behind%20the%20scenes%20mood%2C%20industrial%20aesthetic%2C%20low%20key%20lighting&width=600&height=800&seq=media-video-02&orientation=portrait',
  },
  {
    title: '网红直播间被封最后三分钟',
    duration: '03:22',
    date: '2026.07.16',
    image: 'https://readdy.ai/api/search-image?query=Glitching%20digital%20screen%20with%20streaming%20interface%20breaking%20apart%2C%20pixel%20distortion%20in%20pink%20and%20red%2C%20error%20messages%2C%20dark%20room%20with%20only%20screen%20glow%2C%20cyberpunk%20digital%20decay%20aesthetic%2C%20dramatic%20mood&width=600&height=800&seq=media-video-03&orientation=portrait',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10">
          🎬 视频专区
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/10 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl text-background-50 w-6 h-6 flex items-center justify-center ml-1"></i>
                  </div>
                </div>
                <div className="absolute top-3 right-3 px-2.5 py-1 bg-background-950/70 rounded-md text-xs font-medium text-background-50">
                  {item.duration}
                </div>
              </div>
              <div className="mt-3 px-1">
                <h3 className="text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5">{item.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}